import {conditions} from "../../utility/conditions";
import is_touch_device = conditions.is_touch_device;

function clickOrTap(capitalize = false) {
    const action = is_touch_device() ? "tap" : "click"

    if (capitalize) return action[0].toLocaleUpperCase() + action.substring(1);

    return action;
}

function clickOrTouch(capitalize = false) {
    const action = is_touch_device() ? "touch" : "click"

    if (capitalize) return action[0].toLocaleUpperCase() + action.substring(1);

    return action;
}

const ss = (window as any).ss as any;
const GET_REPORTS = ss && ss.i18n._t('App.ADD_FEATURES', 'Get Reports');

export const intro = {
    title: "Our Environment tour",
    description: `<p>When you first use the mapping tool, you will be presented with a popup window and asked to select one or more environmental data layers to view on the map. You can view the layers in three ways: by topic, category or data source.</p>
    <p>After you have chosen one or more layers, you ${clickOrTap()} the <b>Explore map</b> button. </p>`,
};

export const introTouch = {
    title: "Our Environment tour",
    description: `<p>When you first use the mapping tool, you will be presented with a popup window and asked to select one or more environmental data layers to view on the map. You can view the layers in three ways: by topic, category or data source.</p>
    <p>After you have chosen one or more layers, ${clickOrTap()} the <b>Explore map</b> button. </p>`,
};

export var errorTimeout = {
    title: "Error",
    description: `Sorry the tour ran into an issue and could not complete.`
};

export const tourRestarted = {
    title: "Tour restarted",
    description: `We've detected your browser has been resized, which means some functionality of the site will have changed. Due to this, the <b>tour will now be restarted</b> to handle these differences.`
};

export const myLayers = {
    title: "My Layers",
    description: `The layers you have chosen will appear in the <b>MY LAYERS</b> panel.`
};

export const changeLayers = {
    title: "Changing my layers",
    description: "You can change the layers by pressing the <b>ADD/REMOVE LAYERS</b> button, which will take you back to the previous <b>Configure your map</b> pop up window."
};

export const mapPage = {
    title: "The map page",
    description: `You are now on the map page, with some layers added to the map. This page consists of a main map window, surrounded by a series of panels and controls.  You use the controls to change the view on the map and see more detail, to query the environmental data, and to view and print a map.`
};

export const mainButtons = {
    title: "Panel buttons",
    description: `These large buttons open panels or windows which contain information about the environmental data visible on the map and controls to change the visible map layers.`
};

export const legend = {
    title: "Legend and metadata",
    description: `This panel displays information about the environmental data visible on the map and a legend (key) which is a visual explanation of the symbols used on the map.`
};

export const search = {
    title: "Search",
    description: `Use the search tool to find a place, address or enter geographic coordinates. `
};

export const searchA = {
    title: "Search",
    description: `This button opens the Search tool.`
};

export const searchB = {
    title: `Search window`,
    description: `From this window you can find a place, address or enter geographic coordinates.`
}

export const zoom = {
    title: "Map controls",
    description: `You can use the +/- buttons or your mouse wheel to zoom in and out of the map. ${clickOrTouch(true)} and drag to pan the map.`
};

export const zoomTouch = {
    title: "Map controls",
    description: `You can use the +/- buttons or your mouse wheel to zoom in and out of the map. ${clickOrTouch(true)} and drag the map to pan. A new map will appear.`
}

export const mapLayers = {
    title: "Map layers",
    description: `<p>Map layers are split into three categories - Basemaps, Science and content and Context layers. Toggling these layers on/off results in the corresponding layer being shown on the map.</p>
<p>Only one basemap and one environmental data layer can be displayed on the map at one time.  Multiple Context layers can be shown.</p>`
};

export const mapLayersTablet = {
    title: "Map layers",
    description: `<p>Map layers are split into three categories - Basemaps, Science and content and Context layers. Toggling these layers on/off results in the corresponding layer being shown on the map and information relating to what is shown will be displayed in the  <b>METADATA</b> and <b>LEGEND</b> panels.</p> 
<p>Only one basemap and one environmental data layer can be displayed on the map at one time. Multiple Context layers can be shown.</p>`
};

export const mapLayersMobile = {
    title: "Map layers",
    description: `<p>Map layers are split into three categories - Basemaps, Science and content and Context layers. These layers can be toggled on/off with additional information displayed in the METADATA and LEGEND panels. Only one basemap and one environmental data layer can be displayed on the map at one time. Multiple Context layers can be shown.</p>`
};

export const reportPane = {
    title: GET_REPORTS,
    description: `These controls allow you to generate a report based on a point you select on the map, an area you draw or a predefined extent.`
};

export const reportControlsMobile = {
    title: "Report controls",
    description: `This button opens the reporting controls.  These controls allow you to generate a report based on a point you select on the map, an area you draw or a predefined extent.`
};

export const dropPinAMobile = {
    title: "Dropping pins",
    description: `For example, to generate and view a report for a specific location, ${clickOrTap()} the <b>Drop pin on map</b> button...`
};

export const dropPinA = {
    title: "Dropping pins",
    description: `For example, to generate and view a report for a specific location, ${clickOrTap()} on the <b>Drop pin on map</b> button...`
};

export const dropPinB = {
    title: "Dropping pins",
    description: `...then ${clickOrTap()} on a location on the map.`
};

export const dropPinBTouch = {
    title: "Dropping pins",
    description: `...then ${clickOrTap()} on a location on the map.`
};

export const pinSummary = {
    title: "Report summary",
    description: `A Feature report summary will be displayed in this panel. A full report can be created by ${is_touch_device() ? 'tapping' : 'clicking'} on the <b>Create full report</b> button (demonstrated later in the tour). ${clickOrTap(true)} the <b>BACK</b> button to choose another reporting option.`
};

export const pinSummaryTouch = {
    title: "Report summary",
    description: `A Feature report summary will be displayed in this panel. A full report can be created by ${is_touch_device() ? 'tapping' : 'clicking'} the <b>Create full report</b> button (demonstrated later in the tour).`
};

export const areaReports = {
    title: "Area reports",
    description: `Reports can also be generated for an area defined by you or by choosing a predefined area such as a LINZ NZ or Māori land parcel, a Territorial Authority or Regional Council.`
};

export const linzDemo = {
    title: "LINZ Parcels",
    description: `For this example, generating a report based on a LINZ parcel will be demonstrated.`
};

export const linzDemoAction = {
    title: "Select a parcel",
    description: `Choose the parcel to use for the report, by clicking it on the map`
};

export const linzSummary = {
    title: "LINZ Parcel feature report",
    description: `The LINZ parcel you chose will be displayed on the map, and the report summary will be displayed in the <b>FEATURE REPORT</b> panel.`
};

export const linzFullReport = {
    title: "Creating full reports",
    description: `To view the full report, ${clickOrTap()} the <b>Create full report button</b>. (You must be registered, and logged in to use this feature).`
};

export const fullReports = {
    title: "Reports",
    description: `<p>In this window you can view the report. You can also modify the report in a variety of ways. You can</p>

    <ul>
        <li>Edit the report title</li>
        <li>Add / remove data layers to / from the report</li>
        <li>Change the way the data is visualised</li>
    </ul>
       
    <p>
        You can also
    </p>
    
    <ul>
        <li>Generate a shareable link to the report</li>
        <li>Print the report</li>    
    </ul>`
};

export const printTool = {
    title: "Print tool",
    description: `High quality PDF maps can be generated using the Print tool.`
};

export const printWindow = {
    title: "Print window",
    description: `The print window allows you to choose a title for your printed map, the paper size and orientation, and the map scale. The extent of the map that will be printed is shown by the semi-transparent rectangle.`
};

export const conclusion = {
    title: "Conclusion",
    description: `<p>This concludes your introductory tour. More detailed help is available on the <a href="/help/first-time-here">First Time Here</a> page.</p>
<p>Enjoy exploring New Zealand environmental information with Our Environment!</p>`
};